import ApiClient from "../ApiClient";

const SystemApi = {
  getSystemLists: async () => {
    const response = await ApiClient.get("system/public");
    return response.data.payload || {};
  },
};

export default SystemApi;
